var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanElements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.61083333 7.2225c0-.76666667.62166667-1.38916667 1.38916667-1.38916667.7666667 0 1.3891667.62166667 1.3891667 1.38916667 0 .76666667-.6216667 1.38916667-1.3891667 1.38916667-.7675-.00083334-1.38916667-.6225-1.38916667-1.38916667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.24416667 12.7775c0-.7666667.62166666-1.3891667 1.38916666-1.3891667.76666667 0 1.38916667.6216667 1.38916667 1.3891667-.00083333.7666667-.62166667 1.3891667-1.38916667 1.3891667-.7675 0-1.38916666-.6216667-1.38916666-1.3891667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9775 12.7775c0-.7666667.6216667-1.3891667 1.3891667-1.3891667.7666666 0 1.3891666.6216667 1.3891666 1.3891667 0 .7666667-.6216666 1.3891667-1.3891666 1.3891667-.7675 0-1.3891667-.6216667-1.3891667-1.3891667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 15v-10c0-1.38083333 1.11916667-2.5 2.5-2.5h10c1.3808333 0 2.5 1.11916667 2.5 2.5v10c0 1.3808333-1.1191667 2.5-2.5 2.5h-10c-1.38083333 0-2.5-1.1191667-2.5-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.241667 9.958333-1.008334 1.575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.75 8.391667 1.008333 1.566666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.975 12.775h-1.975"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanElements);
export default __webpack_public_path__ + "static/media/loan-elements.d1c7c06dd524615534befd3ab8de38b6.svg";
export { ForwardRef as ReactComponent };